import axios from 'axios';
import apiConfig from '../config/api';

// Create a separate axios instance for public endpoints (no auth required)
const publicApi = axios.create({
  ...apiConfig,
  // Remove any auth-related interceptors
});

// Add response interceptor to handle rate limits and retries
publicApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If we get a 429 (rate limit) error and haven't retried yet
    if (error.response?.status === 429 && !originalRequest._retry) {
      originalRequest._retry = true;

      // Get retry delay from response headers or use default (60 seconds)
      const retryAfter = error.response.headers['retry-after'] || 60;
      const retryDelay = parseInt(retryAfter, 10) * 1000;

      // Wait for the specified delay
      await new Promise(resolve => setTimeout(resolve, retryDelay));

      // Retry the request
      return publicApi(originalRequest);
    }

    return Promise.reject(error);
  }
);

export default publicApi; 